import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = ({ color = designSystem.colors.neutral400, ...props }) => (
    <Svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <Path
            d="M10.2334 4.66699C11.7267 4.66699 12.4735 4.66646 13.0439 4.95703C13.5457 5.21269 13.9533 5.62128 14.209 6.12305C14.4996 6.69346 14.5 7.44024 14.5 8.93359V11.0664C14.5 12.5598 14.4996 13.3065 14.209 13.877C13.9533 14.3787 13.5457 14.7873 13.0439 15.043C12.4735 15.3335 11.7267 15.333 10.2334 15.333H6.7666C5.27329 15.333 4.52646 15.3335 3.95605 15.043C3.45429 14.7873 3.04668 14.3787 2.79102 13.877C2.50043 13.3065 2.5 12.5598 2.5 11.0664V8.93359C2.5 7.44024 2.50043 6.69346 2.79102 6.12305C3.04668 5.62128 3.45429 5.21269 3.95605 4.95703C4.52646 4.66646 5.27329 4.66699 6.7666 4.66699H10.2334ZM7.75 8V12H9.25V8H7.75Z"
            fill={color}
        />
        <Path
            d="M8.50098 1.41699C9.9276 1.41699 11.0848 2.57341 11.085 4V5.91699H5.91797V4C5.91815 2.57352 7.0745 1.41717 8.50098 1.41699Z"
            stroke={color}
            strokeWidth="1.5"
        />
    </Svg>
);

export default SvgComponent;
